import { resetALL } from "../../../../../../../.globals/redux/actions";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from '../../../../../../../core/data/GraphQLApi';
import { endpoints } from '../../../../../../../core/defaultValues';

const INIT_STATE = {
    loadingUpdate: false,
    update: null,
    error: null
};

export const updatePerformanceImprovementConfig = createAsyncThunk(
    "performanceImprovement/updateConfig",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await clientMutation(
                `
                mutation updateDriverCaseAccountConfig($config: AWSJSON!, $configType: String!) {
                    updateDriverCaseAccountConfig(config: $config, configType: $configType)
                }`,
                {
                    config: JSON.stringify(payload.config),
                    configType: "functions_performanceImprovement"
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            
            // Check for GraphQL errors in response
            if (response.errors && response.errors.length > 0) {
                return rejectWithValue(response.errors[0].message);
            }
            
            return { success: response.updateDriverCaseAccountConfig };
        } catch (exc) {
            // Handle network or other errors
            const errorMessage = exc.errors?.[0]?.message || exc.message || 'Unknown error';
            return rejectWithValue(errorMessage);
        }
    }
);

const performanceImprovementRedux = createSlice({
    name: "performanceImprovement",
    initialState: INIT_STATE,
    reducers: {
        resetPerformanceImprovement(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        builder.addCase(updatePerformanceImprovementConfig.pending, (state) => {
            state.loadingUpdate = true;
        })
        builder.addCase(updatePerformanceImprovementConfig.fulfilled, (state, action) => {
            state.loadingUpdate = false;
            state.update = action.payload;
        })
        builder.addCase(updatePerformanceImprovementConfig.rejected, (state, action) => {
            state.loadingUpdate = false;
            state.update = { success: false, error: action.payload };
        })
    },
});

export const { resetPerformanceImprovement } = performanceImprovementRedux.actions;
export default performanceImprovementRedux.reducer;